import React from "react";
import Box from "@mui/material/Box";

export default function ({ active }) {
  return (
    <Box
      sx={{
        padding: 0,
        margin: 0,
        width: active ? 6 : 5,
        height: active ? 6 : 5,
        opacity: active ? 1 : 0.5,
        backgroundColor: "#FFFFFF",
        borderRadius: "50%",
        boxShadow:
          "0px 1px 1px rgba(0, 0, 0, 0.14), 0px 2px 1px rgba(0, 0, 0, 0.12), 0px 1px 3px rgba(0, 0, 0, 0.2)",
      }}
    ></Box>
  );
}
